import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  	 step: 20 // пикс/дел
  },
  mutations: {
	  
  	scale (state, value) {
  		if ((5 <= value) && (value < 300))
  	    state.step = value;
	  },
  },
  actions: {
	  scale ({state, commit}, { curve }) {
	  	
		  curve.clearRect(0, 0, 320, 320);
		  curve.beginPath();
		  curve.moveTo(0, 160);
		  curve.lineTo(320, 160);
		
		  for (let i = 160; i < 310; i+=state.step) {
			  curve.moveTo(i, 163);
			  curve.lineTo(i, 157);
		  }
		  for (let i = 160; i > 10; i-=state.step) {
			  curve.moveTo(i, 163);
			  curve.lineTo(i, 157);
		  }
		  curve.moveTo(160, 320);
		  curve.lineTo(160, 0);
		
		  for (let i = 160; i < 310; i+=state.step) {
			  curve.moveTo(157, i);
			  curve.lineTo(163, i);
		  }
		  for (let i = 160; i > 10; i-=state.step) {
			  curve.moveTo(157, i);
			  curve.lineTo(163, i);
		  }
		  // Верхняя стрелка
		  curve.moveTo(160, 0);
		  curve.lineTo(165, 10);
		  curve.lineTo(155, 10);
		  curve.lineTo(160, 0);
		  curve.fill();
		  // Правая стрелка
		  curve.moveTo(320, 160);
		  curve.lineTo(310, 165);
		  curve.lineTo(310, 155);
		  curve.lineTo(320, 160);
		  curve.fill();
		
		  curve.stroke();
	  }
  },
  modules: {
  }
})
